import { createContext, useContext, useState } from "react";

export const UIContext = createContext();

export const useUIContext = () => useContext(UIContext);

export const UIProvider = ({ children }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
  const [isUserDropDown, setIsUserDropDown] = useState(false);
  const [botId, setBotID] = useState();
  const [botName, setBotName] = useState();
  const [userType, setUserType] = useState(null);
  const [userId,setUserId]=useState()
  const [dateRanges, setDateRanges] = useState({
    one: [null, null],
    two: [null, null],
    mis: [null, null],
    misDetails: [null, null],
    modifiedReport: [null, null],
    temp:[null,null],
  });

  const [userRights,setUserRights]= useState({
      dealerWrite:false,
      dealerRead:false,
      transactionWrite:false,
      transactionRead:false,
      reportsRead:false
    })

  const resetContext = () => {
    setIsSidebarCollapsed(true);
    setIsUserDropDown(false);
    setBotID(undefined);
    setBotName(undefined);
    setUserType(null);
    setUserId(undefined)
    setUserRights({
      dealerWrite:false,
      dealerRead:false,
      transactionsWrite:false,
      transactionsRead:false,
      reportsRead:false
    })
    setDateRanges({
      one: [null, null],
      two: [null, null],
      mis: [null, null],
      misDetails: [null, null],
      modifiedReport: [null, null],
      temp:[null,null],
    });
  };


  const value = {
    isSidebarCollapsed,
    setIsSidebarCollapsed,
    isUserDropDown,
    setIsUserDropDown,
    botId,
    setBotID,
    botName,
    setBotName,
    userType,
    setUserType,
    dateRanges,
    setDateRanges,
    resetContext,
    userId,
    setUserId,
    userRights,
    setUserRights
  };

  return (
    <UIContext.Provider value={value}>
      {children}
    </UIContext.Provider>
  );
};
